module.exports = __webpack_public_path__ + "img/15.b0a7d87.jpg";